export default "__VITE_ASSET__B9rws7dC__"